/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ExtensionInputs */

const he_nav_extension = /** @type {(inputs: Nav_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף לדפדפן`)
};

const en_nav_extension = /** @type {(inputs: Nav_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Extension`)
};

/**
* | output |
* | --- |
* | "Browser Extension" |
*
* @param {Nav_ExtensionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_extension = /** @type {((inputs?: Nav_ExtensionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ExtensionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_extension(inputs)
	return en_nav_extension(inputs)
});